$(document).ready(function () {

    if ($(".type-post").length > 0) {

        const $mainImage = $(".news-item-detail img.main-image").first();

        if ($mainImage.length > 0) {

            // Desktop/mobile zdroj vybíráme jednou při načtení podle breakpointu 767px
            const isMobile = window.matchMedia("(max-width: 767px)").matches;
            const imageSrc = isMobile ? $mainImage.attr("mobile-src") : $mainImage.attr("desktop-src");

            if (imageSrc) {
                $mainImage.attr("src", imageSrc);
                $mainImage.prependTo(".content-wrapper");
            }
        }

        $(".news-item-detail").css("opacity", "1");
    }
});
